import * as Yup from 'yup';
import { AnySchema } from 'yup';

type EnvironmentTypes = {
	ENABLE_CACHE_VIEW: boolean;
	BETFAN_APPSTORE_ID: string;

	//GOOGLE PAY
	GOOGLE_PAY_ENVIRONMENT: 'PRODUCTION' | 'TEST';
	GOOGLE_PAY_MERCHANT_ID: string;
	GOOGLE_PAY_MERCHANT_NAME: string;
	GOOGLE_PAY_PAYMENT_GATEWAY: string;
	GOOGLE_PAY_PAYMENT_GATEWAY_MERCHANT_ID: string;
};

export const environment: EnvironmentTypes = {
	ENABLE_CACHE_VIEW: import.meta.env.VITE_ENABLE_CACHE_VIEW === 'true',
	BETFAN_APPSTORE_ID: import.meta.env.VITE_BETFAN_APPSTORE_ID,

	//GOOGLE PAY
	GOOGLE_PAY_ENVIRONMENT: import.meta.env.VITE_GOOGLE_PAY_ENVIRONMENT,
	GOOGLE_PAY_MERCHANT_ID: import.meta.env.VITE_GOOGLE_PAY_MERCHANT_ID,
	GOOGLE_PAY_MERCHANT_NAME: import.meta.env.VITE_GOOGLE_PAY_MERCHANT_NAME,
	GOOGLE_PAY_PAYMENT_GATEWAY: import.meta.env.VITE_GOOGLE_PAY_PAYMENT_GATEWAY,
	GOOGLE_PAY_PAYMENT_GATEWAY_MERCHANT_ID: import.meta.env.VITE_GOOGLE_PAY_PAYMENT_GATEWAY_MERCHANT_ID,
};

export const environmentSchema = Yup.object().shape<Record<keyof EnvironmentTypes, AnySchema>>({
	ENABLE_CACHE_VIEW: Yup.boolean().strict(),
	BETFAN_APPSTORE_ID: Yup.number(),

	//GOOGLE PAY
	GOOGLE_PAY_ENVIRONMENT: Yup.string().oneOf(['PRODUCTION', 'TEST']),
	GOOGLE_PAY_MERCHANT_ID: Yup.string(),
	GOOGLE_PAY_MERCHANT_NAME: Yup.string(),
	GOOGLE_PAY_PAYMENT_GATEWAY: Yup.string(),
	GOOGLE_PAY_PAYMENT_GATEWAY_MERCHANT_ID: Yup.string(),
});
